import React, { Component } from 'react';
import './App.css';
import Header from './Header'
import Footer from './Footer'
import { Route, BrowserRouter } from 'react-router-dom'

import MainHome from './MainHome';

import OFirme from './OFirme';
import Reference from './Reference';
import Kontakty from './Kontakty';
import Podpora from './Podpora';

import ProdejInstalaceHWSW from './sluzby-a-produkty/ProdejInstalaceHWSW';
import LokalniVzdalenaSpravaSiti from './sluzby-a-produkty/LokalniVzdalenaSpravaSiti';
import OutsourcingISIT from './sluzby-a-produkty/OutsourcingISIT';
import Webhosting from './sluzby-a-produkty/Webhosting';
import Webdesign from './sluzby-a-produkty/Webdesign';
import CenikPraciASluzeb from './sluzby-a-produkty/CenikPraciASluzeb';
import AuditIS from './sluzby-a-produkty/AuditIS';
import BezpecnostSiti from './sluzby-a-produkty/BezpecnostSiti';
import CoJeToOutsourcing from './sluzby-a-produkty/CojetoOutsourcing';


class Home extends Component {
  render() {
    return (
        <BrowserRouter>
          <div className="App">

              <Header />


              <Route exact path='/' component={MainHome} />

              <Route exact path='/o-firme' component={OFirme} />
              <Route exact path='/reference' component={Reference} />
              <Route exact path='/kontakty' component={Kontakty} />
              <Route exact path='/podpora' component={Podpora} />

              <Route exact path='/sluzby-a-produkty/co-je-to-outsourcing' component={CoJeToOutsourcing} />
              <Route exact path='/sluzby-a-produkty/bezpecnost-siti' component={BezpecnostSiti} />
              <Route exact path='/sluzby-a-produkty/prodej-instalace-servis-hw-sw' component={ProdejInstalaceHWSW} />
              <Route exact path='/sluzby-a-produkty/lokalni-a-vzdalena-sprava-siti' component={LokalniVzdalenaSpravaSiti} />
              <Route exact path='/sluzby-a-produkty/outsourcing-is-it' component={OutsourcingISIT} />
              <Route exact path='/sluzby-a-produkty/audit-is-kontrola-legalnosti-sw' component={AuditIS} />
              <Route exact path='/sluzby-a-produkty/webhosting' component={Webhosting} />
              <Route exact path='/sluzby-a-produkty/webdesign' component={Webdesign} />
              <Route exact path='/sluzby-a-produkty/cenik-praci-a-sluzeb' component={CenikPraciASluzeb} />

              <Footer />

          </div>
        </BrowserRouter>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/Home.js